export const MAX_REVIEW_COUNT = 25;
